import clsx from 'clsx'
import type { ReactNode } from 'react'

/** The app's standard surface: rounded-16 card, hairline border, soft shadow. */
export function Card({ children, className, onClick, inner = false }: {
  children: ReactNode
  className?: string
  onClick?: () => void
  /** Tinted inner row surface (surfaceInner) instead of the main surface. */
  inner?: boolean
}) {
  return (
    <div
      onClick={onClick}
      className={clsx(
        'rounded-xl border border-border-light shadow-feature',
        inner ? 'bg-surface-inner' : 'bg-surface',
        onClick && 'cursor-pointer transition-shadow hover:shadow-lg',
        className,
      )}
    >
      {children}
    </div>
  )
}

/** Uppercase 11px section label (Typography.sectionLabel). */
export function SectionLabel({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={clsx('text-label uppercase text-text-secondary', className)}>{children}</span>
}
